import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none",
  viewBox: "0 0 26 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.978 2.53a.75.75 0 0 1-.387.987 9.25 9.25 0 1 0 12.22 12.08.75.75 0 1 1 1.38.585 10.75 10.75 0 1 1-14.2-14.04.75.75 0 0 1 .987.388Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.76 1.47a.75.75 0 0 1 .531-.22A10.75 10.75 0 0 1 23.041 12a.75.75 0 0 1-.75.75h-10a.75.75 0 0 1-.75-.75V2a.75.75 0 0 1 .22-.53Zm1.281 1.31v8.47h8.47a9.247 9.247 0 0 0-8.47-8.47Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }